/*eslint-disable eqeqeq*/
import React from 'react';
import LensestypeList from '../../../component/componentSupplytool/Lensestype/lensestypeList';
import * as APIController from '../../../../../api/APIController.js';
import Notification from '../../../../../shared/components/notification/notification';

class LensestypeContainer extends React.Component {

    state = {
        currentPage: 1,
        count: 0,
        list: [],
        rowsPerPage: 10,
        rowsPerPageOptions: [10, 25, 50, 'All'],
        from: 0,
        to: 10,
        progress: true,
        message: '',
        showNotification: false,
        isError: false,
        showMessage: this.props.history.location.state != null && this.props.history.location.state.showMessage
    }

    componentDidMount() {
        this.wsGetLensesTypes(this.state.currentPage, this.state.rowsPerPage, this.state.from, this.state.to);
        this.props.history.replace('/supplytool/lensestype/list', null);
    }

    handlebind() {
        this.wsGetLensesTypes(this.state.currentPage, this.state.rowsPerPage)
    }

    wsGetLensesTypes(CurrentPage, RecordPerPage, from, to, BrandName, Name, SequenceNo, IsActive, IsDailyLense) {
        this.setState({ progress: true, });
        APIController.GetLensesTypes(BrandName, Name, SequenceNo, IsActive, IsDailyLense, CurrentPage, RecordPerPage, "Name", "DESC")
            .then((response) => {
                if (response.object.status == 0 && response.object.data.length != 0) {
                    this.setState({
                        to: isNaN(to) ? 1000000 : to,
                        from: from,
                        count: response.object.data[0].MaxRows,
                        list: response.object.data,
                        progress: false,
                    })
                }
                else if (response.object.message && response.object.message.length > 0) {
                    // ToastsStore.warning(response.error.message)
                } else { this.setState({ list: [], progress: false }) }
            })
    }


    render() {
        return (
            <>
                <Notification
                    isError={this.state.isError}
                    message={this.state.message}
                    showNotification={this.state.showNotification}
                    clearNotification={this.handleClearNotification}
                    closeNotification={this.handleClearNotification}
                />
                <section className="content-right-main">
                    <div className="button-field button-field-country">
                        <button onClick={() => {
                            this.props.history.push({
                                pathname: '/supplytool/lensestype/add',
                                state: { lensestypeIdEdit: '0', brandNameEdit: '', sequenceNoEdit: '', lensestypeNameEdit: '', lensestypeActiveEdit: 1, isDailyLenseEdit: 0 }
                            })
                        }}>+ Add Lenses Type</button>
                    </div>

                    <LensestypeList {...this.state}
                        history={this.props.history}
                        handlebind={this.handlebind.bind(this)}
                        handleChangeRowsPerPage={this.handleRowsPerPageChange}
                        handleChangePage={this.handlePageChange}
                        applyFilter={this.handleApplyFilter}
                    />
                </section>
            </>
        )
    }

    handleRowsPerPageChange = (value, BrandName, Name, SequenceNo, IsActive, IsDailyLense) => {
        let from = 0
        let to = value;
        this.setState({ progress: true, rowsPerPage: value, currentPage: 1, to: to, from: from })
        this.wsGetLensesTypes(isNaN(value) ? '' : this.state.currentPage, isNaN(value) ? 1000000 : value, from, to, BrandName, Name, SequenceNo, IsActive, IsDailyLense);
    }

    handlePageChange = (values, BrandName, Name, SequenceNo, IsActive, IsDailyLense) => {
        let from = values === 1 ? 0 * this.state.rowsPerPage : (values - 1) * this.state.rowsPerPage
        let to = values === 1 ? this.state.rowsPerPage : (from + this.state.rowsPerPage);
        this.setState({ currentPage: Number(values) })
        this.wsGetLensesTypes(Number(values), this.state.rowsPerPage, from, to, BrandName, Name, SequenceNo, IsActive, IsDailyLense);
    }

    handleApplyFilter = (BrandName, Name, SequenceNo, IsActive, IsDailyLense) => {
        this.wsGetLensesTypes(this.state.currentPage, this.state.rowsPerPage, this.state.from, this.state.to, BrandName, Name, SequenceNo, IsActive, IsDailyLense)
    }
    handleNotification = (message, isError) => {
        this.setState({
            message: message,
            showNotification: true,
            isError: isError
        })

        setTimeout(() => {
            this.handleClearNotification();
        }, 4000)
    }

    handleClearNotification = () => {
        this.setState({
            message: '',
            showNotification: false,
            isError: false
        })
    }
}

export default LensestypeContainer;